import { IUploadFile } from '../models/file.model';
import { request } from './base';

function upload(file: File) {
  const form = new FormData();

  form.append('file', file);

  return request<IUploadFile>({
    url: '/files',
    method: 'POST',
    data: form,
  });
}

const fileApi = Object.freeze({
  upload,
});

export default fileApi;
